import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { API_URL, pathTherapistHome, pathHomePage, pathLogin } from "../../config/constants";
import VippstarLogo from "../../assets/vippstar_logo.png";
import {
  Container, Card, LogoWrapper, CardTitle, Form,
  Field, Label, Input, Select, Row, SubmitButton, ErrorMsg, LinkText,
} from "./styles";

const Register = () => {
  const history = useHistory();
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    phone: "",
    password: "",
    role: "therapist",
  });
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      history.push(data.user.role === "therapist" ? pathTherapistHome : pathHomePage);
    } catch (err) {
      setError(err.message || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Card style={{ maxWidth: 480 }}>
        <LogoWrapper>
          <img src={VippstarLogo} alt="Vippstar" style={{ width: 90 }} />
        </LogoWrapper>
        <CardTitle>Create account</CardTitle>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Field>
              <Label>First name</Label>
              <Input
                type="text"
                name="first_name"
                placeholder="John"
                value={form.first_name}
                onChange={handleChange}
                required
              />
            </Field>
            <Field>
              <Label>Last name</Label>
              <Input
                type="text"
                name="last_name"
                placeholder="Doe"
                value={form.last_name}
                onChange={handleChange}
                required
              />
            </Field>
          </Row>

          <Field>
            <Label>Username</Label>
            <Input
              type="text"
              name="username"
              placeholder="Choose a username"
              value={form.username}
              onChange={handleChange}
              required
            />
          </Field>

          <Field>
            <Label>Email</Label>
            <Input
              type="email"
              name="email"
              placeholder="your@email.com"
              value={form.email}
              onChange={handleChange}
              required
            />
          </Field>

          <Field>
            <Label>Phone <span style={{ color: "#aaa", fontWeight: 400 }}>(optional)</span></Label>
            <Input
              type="tel"
              name="phone"
              placeholder="+34 600 000 000"
              value={form.phone}
              onChange={handleChange}
            />
          </Field>

          <Field>
            <Label>Password</Label>
            <Input
              type="password"
              name="password"
              placeholder="••••••••••••"
              value={form.password}
              onChange={handleChange}
              required
            />
          </Field>

          <Field>
            <Label>Confirm password</Label>
            <Input
              type="password"
              placeholder="••••••••••••"
              value={confirmPassword}
              onChange={(e) => { setConfirmPassword(e.target.value); setError(""); }}
              required
            />
          </Field>

          {error && <ErrorMsg>{error}</ErrorMsg>}
          <SubmitButton type="submit" disabled={loading}>
            {loading ? "Creating account..." : "Create account"}
          </SubmitButton>
        </Form>
        <LinkText>
          Already have an account? <Link to={pathLogin}>Sign in</Link>
        </LinkText>
      </Card>
    </Container>
  );
};

export default Register;
